import React, { Fragment } from 'react';

import * as Actions from 'inpc/components/list/actions';

const InpcActions = ({ permissions, inpc, company, handleToggle }) => {
  return (
    <Fragment>
      {permissions['acl.inpc.update'] && <Actions.Edit inpc={inpc} company={company} />}
    </Fragment>
  );
};

export default InpcActions;



// WEBPACK FOOTER //
// src/modules/secured/modules/inpc/components/list/InpcActions.js